import React from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { formatRuDate } from "@/lib/format";
import type { DuplicateInfo } from "@/types/api";

export interface DuplicateEntry {
  filename: string;
  document_number: string | null;
  duplicate: DuplicateInfo;
}

interface Props {
  open: boolean;
  duplicates: DuplicateEntry[];
  onSkip: () => void;
  onForce: () => void;
  onCancel: () => void;
}

export function DuplicateConfirmDialog({
  open,
  duplicates,
  onSkip,
  onForce,
  onCancel,
}: Props): React.ReactElement {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Найдены уже загруженные документы</DialogTitle>
          <DialogDescription>
            Эти файлы соответствуют документам, которые уже есть в системе.
            Что с ними сделать?
          </DialogDescription>
        </DialogHeader>

        <ul className="space-y-2 text-sm">
          {duplicates.map((d, i) => (
            <li
              key={`${d.filename}-${i}`}
              className="rounded-md border bg-muted/30 p-3"
              title={d.filename}
            >
              <div className="font-medium">
                {d.document_number
                  ? `Счёт-фактура № ${d.document_number}`
                  : "Файл без распознанного номера"}
              </div>
              <div className="text-xs text-muted-foreground">
                Этот документ уже был загружен{" "}
                {formatRuDate(d.duplicate.uploaded_at)}
              </div>
            </li>
          ))}
        </ul>

        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="ghost" onClick={onCancel}>
            Отмена
          </Button>
          <Button variant="outline" onClick={onForce}>
            Загрузить всё равно
          </Button>
          <Button onClick={onSkip}>Пропустить дубли</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
